var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill:none;}.cls-2{fill:#f2f2f2;}.cls-12,.cls-13,.cls-14,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8{stroke:#000;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3,.cls-6{stroke-width:5px;}.cls-3{fill:#668bff;}.cls-4,.cls-7{stroke-width:4.75px;}.cls-5{stroke-width:2px;}.cls-7{stroke:#668bff;}.cls-8{stroke-width:6.56px;}.cls-9{clip-path:url(#clip-path);}.cls-10,.cls-11{stroke:#e5e4e5;}.cls-10{stroke-width:2.46px;}.cls-11{stroke-width:2.59px;}.cls-12{stroke-width:5.02px;}.cls-13{stroke-width:8.23px;}.cls-14{stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M820.77,474.93c-3-16.35-4.46-37.15-11.89-38.63s-13.37-46.06-22.29-43.09c-10.4-14.86-14.86-43.09-22.28-35.66s-28.24-46.06-32.69-43.09c-7.43,1.49-14.86-22.29-22.29-20.8s-16.34-7.43-25.26-13.37c0,0-17.83-16.35-26.74-17.83s-35.66-3-40.12-5.95-32.69-4.45-37.14-4.45-26.75,5.94-32.69,4.45-28.23,0-34.18,1.49-26.74,8.91-31.2,14.86-28.23,7.43-32.69,11.88-32.68,20.8-32.68,23.78-23.78,31.2-26.75,35.66S373.54,368,373.54,370.92s-16.35,35.66-20.8,40.12-16.35,26.74-14.86,32.68S329,458.58,329,469s-8.17,40.86-5.94,60.92,23.24,57.26,38,86.65c3.86,28.4,37.77,90.16,37.77,90.16,3-8.91,0-112.92,7.43-123.32S446.34,489.78,453.77,469s37.15-29.71,60.92-40.11,37.14-19.32,38.63-17.83,37.15,17.83,53.49,14.86,37.14-5.95,41.6-3,43.09,63.89,69.84,90.64S748,642.8,748,699.28c0,20.62,16.53-.76,24.89-60.55C794.12,594.66,844.17,480.78,820.77,474.93Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "651.38 1018.66 651.38 974.9 651.38 886.5 498.35 886.5 498.35 1019.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M496.12,974.9c-5.2,5.2-49.78,20.06-24.52,34.92,43.49,25.58,177.22,22.72,215.44-6,17.83-13.37-8.91-28.23-35.66-29,0,0,139.63-12.21,225.81,54.65L999.06,1200l-798.12-.45s83-179.5,190-206.25C428.36,984,483.49,977.13,496.12,974.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.33,979.36c53.49,10.4,46.06,62.4-111.44,63.89s-159-65.38-75.77-68.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.4,1004.62c-1.48-3,3-25.26,30.25-27.36,7.13-.55,2.61,34.2.32,38C494.54,1019.2,470.28,1012.37,466.4,1004.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.81,998.93c1.49-3-8.94-19-36.23-21.06-7.12-.55-5.26,34.88-3,38.63C656.05,1020.49,688.94,1006.68,692.81,998.93Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 472.19,
    y1: 988.3,
    x2: 446.44,
    y2: 990.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 464.06,
    y1: 993.93,
    x2: 442.5,
    y2: 996.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 464.06,
    y1: 998.74,
    x2: 441.56,
    y2: 1006.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 466.56,
    y1: 1005.18,
    x2: 449.06,
    y2: 1016.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 471.6,
    y1: 1009.82,
    x2: 461.56,
    y2: 1023.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 481.56,
    y1: 1016.43,
    x2: 472.1,
    y2: 1030.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 691.56,
    y1: 993.93,
    x2: 712.81,
    y2: 1005.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 688.62,
    y1: 1002.58,
    x2: 704.76,
    y2: 1016.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 680.59,
    y1: 1009.09,
    x2: 689.06,
    y2: 1023.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 670.31,
    y1: 1015.18,
    x2: 672.81,
    y2: 1030.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 657.23,
    y1: 1017.11,
    x2: 660.41,
    y2: 1034.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 641.79,
    y1: 1020.82,
    x2: 642.81,
    y2: 1036.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 625.89,
    y1: 1023.93,
    x2: 627.81,
    y2: 1041.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 609.93,
    y1: 1025.93,
    x2: 608.67,
    y2: 1041.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 494.54,
    y1: 1019.85,
    x2: 488.74,
    y2: 1035.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 512.81,
    y1: 1023.93,
    x2: 509.03,
    y2: 1039.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 526.56,
    y1: 1027.68,
    x2: 525.31,
    y2: 1042.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 543.13,
    y1: 1027.05,
    x2: 542.56,
    y2: 1042.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 555.77,
    y1: 1027.05,
    x2: 555.31,
    y2: 1042.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 570.31,
    y1: 1028.93,
    x2: 571.56,
    y2: 1042.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 586.56,
    y1: 1028.93,
    x2: 587.83,
    y2: 1042.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 600,
    y1: 1027.05,
    x2: 600,
    y2: 1042.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M651.55,964c45.64,20.57-43.11,235.57-65.61,235.57s-160-228.75-90-228.75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M750.93,715.63s47.13-1.49,47.13-39.7-40.45-40.46-40.45-40.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M762.51,703.78a19.32,19.32,0,1,0,28.65-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M392.44,715.63s-47.13-1.49-47.13-39.7,40.45-40.46,40.45-40.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M352.61,705.15a19.32,19.32,0,1,0,28.47-3.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M754.65,719.34c3,10.4,14.86,59.43-8.92,62.41s-35.66-10.4-28.23,23.77,26.75,87.66-38.63,101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M733.85,722.31c-4.46,17.83,46.06,83.21,19.31,86.18s-50.52,1.49-50.52,16.34S719,902.1,701.16,914"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M726.42,747.57c-5.95,22.29,40.11,69.83,25.26,78.75s-56.46,13.37-65.38,34.17-8.91,25.26-16.34,28.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M399.6,720.94c-3.72,10.4-19.13,59.43,4.43,62.32s36.4-10.53,26.52,23.64-18.16,105.85,46.25,119"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M420.19,723.83c3.17,17.8-52.05,83.3-25.52,86.17s50.41,1.3,49.34,16.15-21.9,77.25-4.93,89.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M425.8,749c4.34,22.25-45.14,69.92-30.93,78.77s55.5,13.16,62.92,33.91,7.1,25.2,14.31,28.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M761.24,660.53C749.86,794.38,635,925.13,574.12,925.13S402.6,815.18,387,660.53c0-146.14,77.9-264.6,187.11-264.6S761.24,514.39,761.24,660.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M356.45,579.68c-8.91,7.43-1.48,81.72-28.23,83.2S291.08,648,292.56,636.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M371.31,616.82c-1.49,5.94-13.37,93.61-41.6,92.12s-11.89-49,5.94-37.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.77,474.93c-3-16.35-4.46-37.15-11.89-38.63s-13.37-46.06-22.29-43.09c-10.4-14.86-14.86-43.09-22.28-35.66s-28.24-46.06-32.69-43.09c-7.43,1.49-14.86-22.29-22.29-20.8s-16.34-7.43-25.26-13.37c0,0-17.83-16.35-26.74-17.83s-35.66-3-40.12-5.95-32.69-4.45-37.14-4.45-26.75,5.94-32.69,4.45-28.23,0-34.18,1.49-26.74,8.91-31.2,14.86-28.23,7.43-32.69,11.88-32.68,20.8-32.68,23.78-23.78,31.2-26.75,35.66S373.54,368,373.54,370.92s-16.35,35.66-20.8,40.12-16.35,26.74-14.86,32.68S329,458.58,329,469s-8.17,40.86-5.94,60.92,23.24,57.26,38,86.65c3.86,28.4,37.77,90.16,37.77,90.16,3-8.91,0-112.92,7.43-123.32S446.34,489.78,453.77,469s37.15-29.71,60.92-40.11,37.14-19.32,38.63-17.83,37.15,17.83,53.49,14.86,37.14-5.95,41.6-3,43.09,63.89,69.84,90.64S748,642.8,748,699.28c0,20.62,16.53-.76,24.89-60.55C794.12,594.66,844.17,480.78,820.77,474.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M401,691.11c-10.41-35.66-69.84-155.4-77.27-211"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M332.68,446c-5.16,23.76,60.5,198.82,71.32,206.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M341.59,420.69C338,444.57,391.25,604,404,616.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M387.65,331.55C383.2,347.89,427.77,484.58,453,492"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M454.51,469.73c-13.37-16.35-62.5-132.76-55-150.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M467.89,463.78C441.14,426.64,407,315.2,411.43,303.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 543.66,
    y1: 240.91,
    x2: 551.09,
    y2: 414.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 561.49,
    y1: 240.91,
    x2: 561.49,
    y2: 414.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M595.67,240.91c5.94,8.92-3,188.7-3,188.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M579.32,242.4c4.46,5.94-3,184.24-3,184.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M620.92,246.86C631.33,276.57,609,429.61,609,429.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 718.99,
    y1: 288.46,
    x2: 675.9,
    y2: 460.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M744.25,319.66c1.48,23.77-38,165.18-46.06,170.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M769.51,353.83c-4.64,18.1-46.72,155.75-50.52,160.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M799.22,402.87c.6,31.47-56.63,195.41-59.43,191.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M814.08,443c-6.3,20.46-72,195.87-74.29,187.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M821.71,467.86s-75.18,192.49-76,184.62"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M533.26,707.46c-5.94,0-7.43,13.37,0,17.83s21.67-14.06,26.46-5.23c5.68,10.48,21.51,14.21,29.13-.63,4.87-9.48,15.66,3.63,23.87,2.52s8-16.63.64-19.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M529.11,792.89c3.21,49,86.38,49,88.84,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M434.61,591.56c22.34-26.78,50.07-26.79,84.69,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M627.76,591.56q48.65-35.05,84.69,0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 673.25,
    cy: 631.68,
    rx: 14.28,
    ry: 19.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M685.13,620.82c4.8.12,14.8-6.13,14.8-8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M676.38,617.07c4.8.12,14.8-6.13,14.8-8.63"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 483.65,
    cy: 631.68,
    rx: 14.28,
    ry: 19.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M471.78,620.82c-4.81.12-14.81-6.13-14.81-8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M480.53,617.07c-4.81.12-14.81-6.13-14.81-8.63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar04);
export default __webpack_public_path__ + "static/media/Avatar-04.ac73a81afcae1a7cfa627248fa2e7b4e.svg";
export { ForwardRef as ReactComponent };